// Declare PhotoSwipe types for window
declare global {
  interface Window {
    PhotoSwipeLightbox: any;
    PhotoSwipe: any;
  }
}

document.addEventListener("click", (event) => {
  const button = (event.target as HTMLElement).closest<HTMLElement>(".see-more-rating-body-btn");
  if (!button) return;

  const commentText = button.previousElementSibling as HTMLElement;
  const fullComment = commentText?.dataset.fullComment;
  if (!fullComment) return;

  const isTruncated = commentText.dataset.truncated !== "false";
  commentText.textContent = isTruncated ? fullComment : fullComment.substring(0, 250) + "...";
  button.textContent = isTruncated ? button.dataset.less : button.dataset.more;
  commentText.dataset.truncated = isTruncated ? "false" : "true";
});

// Export initialization function so it can be called on dynamically loaded content
export function initializeSpProfile(container: HTMLElement | Document = document) {
  // This script handles the "load more" functionality for review sections on the page.
  // There are two modes:
  // 1. "paginate": New review items are fetched from the server in batches (pagination).
  // 2. "preload": All review items are already in the DOM but only a subset is visible initially; clicking reveals more.
  container.querySelectorAll<HTMLElement>(".ratings_section").forEach((section) => {
    // Get the loading mode from the data attribute (e.g., "paginate" or "preload")
    const loadMode = section.dataset.loadMode;

    // Find the "load more" button within the section
    const loadMoreBtn = section.querySelector<HTMLButtonElement>(".load-more-btn");
    if (!loadMoreBtn) return; // Exit if no button found

    if (loadMode === "paginate") {
      // PAGINATE MODE: Fetch new reviews from the server when the button is clicked

      // Attach a click event listener to the "load more" button
      loadMoreBtn.addEventListener("click", function () {
        // Retrieve the next page number from the button's data attribute (defaulting to 0 if not set)
        let nextPage = parseInt(loadMoreBtn.dataset.nextPage || "0", 10);

        // Get necessary IDs from the section's data attributes
        const serviceProviderId = section.dataset.serviceProviderId;
        const semCategoryId = section.dataset.semCategoryId;

        // Find the container where the reviews are displayed
        const ratingsContainer = section.querySelector(".ratings-container");

        // If any required data is missing, exit the function
        if (!serviceProviderId || !semCategoryId || !ratingsContainer) return;

        // Build the URL for fetching evaluations with pagination parameters
        // The offset is calculated by multiplying the current page number by the number of reviews per page (3)
        const url = `/service_providers/${serviceProviderId}/evaluations?sem_category=${semCategoryId}&limit=3&offset=${nextPage * 3}`;

        console.log("Fetching URL: ", url);

        // Fetch data from the constructed URL
        fetch(url)
            .then((response) => response.text()) // HTML response
            .then((html) => {
              // Check if the returned HTML content is not empty
              if (html.trim() !== "") {
                // Append the new reviews to the ratings container
                ratingsContainer.insertAdjacentHTML("beforeend", html);
                // Increment the page counter and update the button's data attribute
                nextPage++;
                loadMoreBtn.dataset.nextPage = nextPage.toString();
              }

              // If no more reviews are returned, hide the load more button
              if (html.trim() === "") {
                loadMoreBtn.style.display = "none";
              }
            })
            .catch((error) => console.error("Error loading more evaluations:", error));
      });
    } else {
      // PRELOAD MODE: All reviews are already on the page but only a few are shown initially.
      // More reviews are revealed in batches on clicking the "load more" button.

      // Select all review items within the section
      const reviews = section.querySelectorAll<HTMLElement>(".rating-item");
      // Define the number of reviews to show initially (and the increment per click)
      let visibleCount = 3;

      // Add a click event listener to the "load more" button to reveal more reviews
      loadMoreBtn.addEventListener("click", function () {
        // Loop through the next batch of reviews and set their display to "block" (visible)
        for (let i = visibleCount; i < visibleCount + 3 && i < reviews.length; i++) {
          reviews[i].style.display = "block";
        }
        // Increase the count of visible reviews by 3
        visibleCount += 3;

        // If all reviews are now visible, hide the "load more" button
        if (visibleCount >= reviews.length) {
          loadMoreBtn.style.display = "none";
        }
      });

      // If the initial visible count is already equal to or exceeds the total reviews,
      // hide the "load more" button immediately.
      if (visibleCount >= reviews.length) {
        loadMoreBtn.style.display = "none";
      }
    }
  });



  // Initialize Swiper
  if (window.Swiper && window.Mousewheel) { // ✅ Check if Mousewheel exists
    new window.Swiper(".sp_profile_portfolio_swiper", {
      direction: "horizontal",
      slidesPerView: "auto",
      spaceBetween: 10,
      keyboard: {
        enabled: true,
        onlyInViewport: false
      },
      mousewheel: {
        forceToAxis: true, // Ensures scrolling only affects Swiper
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      modules: [window.Mousewheel, window.Navigation, window.Keyboard],
    });

    new window.Swiper(".sp_profile_similars_sp", {
      slidesPerView: 'auto',
      spaceBetween: 15,
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 25,
        }
      },
    });
  } else {
    console.error("Swiper or Mousewheel is not defined. Ensure they are properly loaded.");
  }

  // Initialize PhotoSwipe lightbox for portfolio images
  initializePhotoSwipe(container);
}

function askForOffersendMessageToIframe(button: HTMLElement) {
    const conversationId = button.getAttribute('data-conversation-id');
    const message = button.getAttribute('data-ask-an-offer-message');
    const successMessage = button.getAttribute('data-ask-an-offer-success-message');
    const errorMessage = button.getAttribute('data-ask-an-offer-error-message');

    if (!conversationId || !message || !successMessage || !errorMessage) {
      return;
    }

    const allMatchingButtons = document.querySelectorAll(`button[data-conversation-id="${conversationId}"]`);

    let iframe = document.querySelector(`iframe[src*='/conversations/${conversationId}']`) as HTMLIFrameElement | null;

    if (!iframe) {
      iframe = document.querySelector(`iframe[data-offcanvas-src*='/conversations/${conversationId}']`) as HTMLIFrameElement | null;
    }

    if (!iframe) {
      askAnOfferdisplayMessage(conversationId, errorMessage, 'danger', button);
      return;
    }

    function sendMessage() {
      if (!iframe.contentWindow) {
        askAnOfferdisplayMessage(conversationId, errorMessage, 'danger', button);
        return;
      }

      iframe.contentWindow.postMessage({
        type: 'ask_offer_button',
        conversationId: conversationId,
        message: message
      }, '*');

      askAnOfferdisplayMessage(conversationId, successMessage, 'success', button);

      allMatchingButtons.forEach((btn) => {
        btn.setAttribute('disabled', 'true');
      });
    }

    const hasRealSrc = iframe.src && iframe.src !== '' && !iframe.src.includes('about:blank');
    const isLoaded = iframe.contentWindow && iframe.contentWindow.document.readyState === 'complete';
    const contentLocation = iframe.contentWindow?.location.href;

    if (hasRealSrc && isLoaded && contentLocation && !contentLocation.includes('about:blank')) {
      sendMessage();
    } else {
      iframe.onload = sendMessage;
    }
  }

function askAnOfferdisplayMessage(conversationId, message, messageType, button) {
    const messageDiv = document.createElement('div');
    messageDiv.classList.add('text-center', 'mt-3', 'w-100', 'text-sm');
    messageDiv.innerHTML = message;
    button.parentElement.insertBefore(messageDiv, button.nextSibling);
}

// Initialize PhotoSwipe lightbox for portfolio images
function initializePhotoSwipe(container: HTMLElement | Document) {
  const portfolioSwiper = container.querySelector('.sp_profile_portfolio_swiper');

  if (!portfolioSwiper || typeof window.PhotoSwipeLightbox === 'undefined' || typeof window.PhotoSwipe === 'undefined') {
    return;
  }

  // PRELOAD FULL-SIZE IMAGE DIMENSIONS
  const sizeMap: Record<string, { w: number; h: number }> = {};

  // Loop over every <a> in our gallery that isn't the "See more" link
  container.querySelectorAll('.sp_profile_portfolio_swiper a:not(.bg-pink-50)').forEach((anchor: Element) => {
    const href = (anchor as HTMLAnchorElement).href;
    const src = href; // URL of the full-size image
    const img = new Image(); // Create an off-DOM Image object

    // When it finishes loading, stash its real dimensions
    img.onload = () => {
      sizeMap[src] = {
        w: img.naturalWidth,
        h: img.naturalHeight
      };
    };

    // Kick off the load
    img.src = src;
  });

  // INITIALIZE THE LIGHTBOX
  const lightbox = new window.PhotoSwipeLightbox({
    gallery: '.sp_profile_portfolio_swiper', // CSS selector for your Swiper container
    children: 'a:not(.bg-pink-50)', // Each <a> inside that container is an item
    pswpModule: window.PhotoSwipe, // Underlying core module
    zoom: false, // Disable built-in zoom animation
    counter: false, // Disable the default "1/10" counter
    preload: [1, 2] // Preload 1 slide before & 2 after the current
  });

  // INJECT DIMENSIONS VIA domItemData FILTER
  lightbox.addFilter('domItemData', (itemData: any, element: HTMLElement) => {
    const src = element.getAttribute('href'); // Full-size image URL

    if (src && sizeMap[src]) {
      // Use the real dimensions if we have them
      itemData.w = sizeMap[src].w;
      itemData.h = sizeMap[src].h;
    } else {
      // Fallback: use the thumbnail's natural size
      const thumb = element.querySelector('img') as HTMLImageElement;
      if (thumb && thumb.naturalWidth && thumb.naturalHeight) {
        itemData.w = thumb.naturalWidth;
        itemData.h = thumb.naturalHeight;
      }
    }

    return itemData; // Return the modified data back to PhotoSwipe
  });

  // ACTIVATE THE LIGHTBOX
  lightbox.init();
}

// Make it available globally for inline script usage
(window as any).initializeSpProfile = initializeSpProfile;

// Initialize on page load
document.addEventListener("DOMContentLoaded", function () {
  initializeSpProfile(document);
});

document.addEventListener('click', (event) => {
  const target = event.target as HTMLElement;
  if (target.matches("[data-ask-an-offer-action='ask-an-offer']")) {
    askForOffersendMessageToIframe(target);
  }
});
